import { ProfileHeader } from "./components/ProfileHeader";
import { useMetadataUser } from "contexts/metadata-user-context";

const AvatarDropdown = () => {
  const { profile } = useMetadataUser();

  return (
    <div className="AvatarDropdown">
      <ProfileHeader profile={profile} />
    </div>
  );
};

export default AvatarDropdown;
